var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormula(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 3.87467C4.375 3.56526 4.49792 3.26851 4.71671 3.04972C4.9355 2.83092 5.23225 2.70801 5.54167 2.70801H11.9583C12.2678 2.70801 12.5645 2.83092 12.7833 3.04972C13.0021 3.26851 13.125 3.56526 13.125 3.87467V4.16634C13.1253 4.37298 13.0525 4.57306 12.9194 4.73115C12.7863 4.88923 12.6016 4.99512 12.3979 5.03005C12.1943 5.06498 11.9848 5.02671 11.8067 4.92201C11.6285 4.81731 11.4932 4.65294 11.4246 4.45801H6.2545L9.85133 7.54092C9.95359 7.62854 10.0357 7.73726 10.092 7.8596C10.1482 7.98194 10.1774 8.11501 10.1774 8.24967C10.1774 8.38434 10.1482 8.51741 10.092 8.63975C10.0357 8.76209 9.95359 8.8708 9.85133 8.95842L6.2545 12.0413H11.4246C11.4932 11.8464 11.6285 11.682 11.8067 11.5773C11.9848 11.4726 12.1943 11.4344 12.3979 11.4693C12.6016 11.5042 12.7863 11.6101 12.9194 11.7682C13.0525 11.9263 13.1253 12.1264 13.125 12.333V12.6247C13.125 12.9341 13.0021 13.2308 12.7833 13.4496C12.5645 13.6684 12.2678 13.7913 11.9583 13.7913H5.54167C5.23225 13.7913 4.9355 13.6684 4.71671 13.4496C4.49792 13.2308 4.375 12.9341 4.375 12.6247V11.8838C4.37501 11.7156 4.41141 11.5494 4.48169 11.3965C4.55197 11.2437 4.65447 11.1079 4.78217 10.9983L7.98875 8.24967L4.78217 5.50159C4.65439 5.39201 4.55185 5.25608 4.48157 5.10313C4.41128 4.95018 4.37493 4.78383 4.375 4.61551V3.87467Z",
    fill: "#2E3438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormula);
export default __webpack_public_path__ + "static/media/formula.71cc8b33482c0d79ea6bbe9c4a874cd1.svg";
export { ForwardRef as ReactComponent };